module.exports = __webpack_public_path__ + "static/media/ellipse 3.7412b4c8.webp";